(function($) {
    "use strict";

    $.DualMap = function (options) {
        options = options || {};
        this.viewers = options.viewers || window.viewers[0] || [];
        this._containers = options.containers || [];
        this._tile_source_left = options.tile_source_left || 'data_deepzoom/deepzoom.dzi';
        this._tile_source_right = options.tile_source_right || 'data_ortho/deepzoom.dzi';
        this._slider_button = document.getElementById('slider-button');
        
        this.slider_button = document.getElementById('slider-button');
    
        this.left_image = null;
        this.left_image_flag = false;
        this.right_image = null;
        this.right_image_flag = false;
        this._left_rect = new OpenSeadragon.Rect( 0,0,0,0 );
        this._right_rect = new OpenSeadragon.Rect( 0,0,0,0 );
    
        this.division_pt = new OpenSeadragon.Point(0.0, 0.0); 
    
        this._leading_viewer = null;
        
        // adjust viewports when
        $.on("location_provider_ready", this.initial_adjustment.bind(this));
 
        // bind events
        this._container_manipulation_event_handler = this._container_manipulation_event_handler.bind(this)

        this.init();
    };

    $.DualMap.prototype = {
        init: function() {
            this._pre_check();
            this.initial_adjustment();
            if (this.slider_button) {
                jQuery(this.slider_button).draggable({
                    containment: '#' + this._container_id,
                    scroll: false
                });
            }

            //■■■全てを選択不可にする（ナビドラッグ対策）
            document.onselectstart = function(){ return false; };

            if (this.viewers.length == 1) {

                //■■■ナビゲーター使用不可にする
                // this.viewers[0].navigator.setMouseNavEnabled(false);

                var self = this;
                this.viewers[0].addHandler('animation', function (viewer) {
                    self._images_clip();
                });
            }

            if (this._containers.length == 1) {
                var container = this._containers[0];
                var $container = jQuery(this._containers[0]);
                this.division_pt = new OpenSeadragon.Point( $container.width() / 2, $container.height() / 2 );
                jQuery(container).hover(
                    //mouseenter
                    function(e) {
                    },
                    //mouseleave
                    function(e) {
                        jQuery(container).trigger("mouseup");
                    }
                );
            }
            else if (this._containers.length == 2) {
                this._bind_containers_events(); 

                /** @type {OpenSeadragon.Viewer} */
                var left_viewer = this.viewers[0];
                /** @type {OpenSeadragon.Viewer} */
                var right_viewer = this.viewers[1]; 

                /**
                 * Functionality of buttons to hide left and right containers, and restoring their state (zoom, position) after showing
                 */
                var self = this;
                var button_hide_left = document.querySelector(".hide-left-container");
                if (button_hide_left) {  
                    button_hide_left.addEventListener(ABDOUtil.getClickHandler(button_hide_left), function(event){
                        self._toggle_viewer.call(self, left_viewer, right_viewer);
                    });
                }

                var button_hide_right = document.querySelector(".hide-right-container");
                if (button_hide_right) { 
                    button_hide_right.addEventListener(ABDOUtil.getClickHandler(button_hide_right), function(event){
                        self._toggle_viewer.call(self, right_viewer, left_viewer); 
                    });
                }
            }
        },

        /**
         * Toggle the display of viewer.
         * 
         * When hiding unbinds the events linked to "other viewer".
         * When showing binds events between viewers and adjust the viewports just after the "update-viewport" event
         * 
         * @param {OpenSeadragon.Viewer} viewer 
         * @param {OpenSeadragon.Viewer} other_viewer 
         */
        _toggle_viewer: function(viewer, other_viewer) { 
            var container = viewer.container.parentElement;
            var other_container = other_viewer.container.parentElement;
            let self = this;
            // if invisible
            if (container.style.display === "none") { 
                container.style.display = "";
                other_container.style.width = "";

                // adjust newly visible viewport to map
                viewer.addOnceHandler("update-viewport", function(evt){     
                    self._adjust_viewport(other_viewer, viewer);
                    self._bind_containers_events();
                });
            }
            else if (other_container.style.display !== "none") { // else if other is also visible
                this._unbind_containers_events(); 
                container.style.display = "none";
                other_container.style.width = "100%";
            }
        },

        _bind_containers_events: function() {
            var viewer, i, viewers_n = this.viewers.length; 

            for (i = 0; i < viewers_n; i++) {
                viewer = this.viewers[i];
                viewer.addHandler('zoom', this._container_manipulation_event_handler);
                viewer.addHandler('pan', this._container_manipulation_event_handler);
                viewer.addHandler('rotate', this._container_manipulation_event_handler);

                // viewer.innerTracker = this.viewers[0].innerTracker;
                // viewer.outerTracker = this.viewers[0].outerTracker;
            }
        }, 

        _unbind_containers_events: function() {
            var viewer, i, viewers_n = this.viewers.length;
 
            for (i = 0; i < viewers_n; i++) {
                viewer = this.viewers[i];   
                viewer.removeHandler('zoom', this._container_manipulation_event_handler);
                viewer.removeHandler('pan', this._container_manipulation_event_handler);
                viewer.removeHandler('rotate', this._container_manipulation_event_handler); 
            } 

        }, 

        /**
         * Returns the viewer with the smallest scale obtained by its get_scale() method
         * @returns {OpenSeadragon.Viewer}
         */
        _get_smallest_viewer: function() {
            var i, viewer, smallest_scale;
            // select view with smaller area scale
            var smallest_viewer = null; 
            for (i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                var localization = ABDOUtil.get_viewer_localization(viewer);

                if (localization) {
                    if (i == 0) {
                        smallest_viewer = viewer;
                        smallest_scale = localization.get_scale();
                    }
                    else {
                        var scale = localization.get_scale();
                        if (scale < smallest_scale) {
                            smallest_scale = scale;
                            smallest_viewer = viewer;
                        }
                    }
                }
            }

            return smallest_viewer;
        },

        /**
         * Adjust all the viewers to the smallest scale viewer.
         * If the viewer doesnt have GPS, it does nothing
         * @function
         */
        initial_adjustment: function() {
            var smallest_viewer = this._get_smallest_viewer();
            if (smallest_viewer) {
                // if localization available and is nonlinear
                // center viewer to the centroid of its reference points
                var localization = ABDOUtil.get_viewer_localization(smallest_viewer);

                if (localization) {
                    // var center = localization.get_viewport_center();
                    var rect = localization.get_viewport_rect();
                    smallest_viewer.viewport.fitBounds(rect, true);
                    // smallest_viewer.viewport.panTo(center);  
                }
                
                for (var i = 0; i < this.viewers.length; i++) {
                    var viewer = this.viewers[i];

                    if (viewer == smallest_viewer) {
                        continue;
                    } 

                    this._adjust_viewport(smallest_viewer, viewer);
                }
            }
            
        },

        /**
         * Adjust viewer's viewport to "leading" zoom pan and rotation
         * @function
         * @param {OpenSeadragon.Viewer} leading 
         * @param {OpenSeadragon.Viewer} viewer 
         */
        _adjust_viewport: function(leading, viewer) {
            var leading_localization = ABDOUtil.get_viewer_localization(leading); 
            var viewer_localization = ABDOUtil.get_viewer_localization(viewer);

            // if has localization 
            if (viewer_localization && leading_localization) {
                var viewer_scale = viewer_localization.get_scale();
                var leading_scale = leading_localization.get_scale();

                var zoom_scaling = viewer_scale / leading_scale;

                // get leading lonlat
                var leading_center = leading.viewport.getCenter();
                var leading_center_lonlat = leading_localization.vp2lonlat(leading_center.x, leading_center.y);

                // perhaps outside convex hull of nonlinear
                // just do nothing if this happens
                if (leading_center_lonlat == false) {
                    return;
                }

                // get viewer point from leading lonlat
                var viewer_pt = viewer_localization.lonlat2vp(leading_center_lonlat[0], leading_center_lonlat[1]);
                if (viewer_pt == false)  {
                    return;
                }

                viewer_pt = new OpenSeadragon.Point(viewer_pt[0], viewer_pt[1]);

                viewer.viewport.zoomTo(leading.viewport.getZoom() * zoom_scaling);
                viewer.viewport.panTo(viewer_pt);
                viewer.viewport.setRotation(leading.viewport.getRotation()); 
               
            }
            else {
                viewer.viewport.zoomTo(leading.viewport.getZoom());
                viewer.viewport.panTo(leading.viewport.getCenter());
                viewer.viewport.setRotation(leading.viewport.getRotation());
            }
            
        },

        _container_manipulation_event_handler: function(evt) {
            if (this._leading_viewer == null) {
                this._leading_viewer = evt.eventSource;
            }

            if (this._leading_viewer != evt.eventSource) {
                return;
            } 
            
            var i, viewer;
            for (i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];

                if (viewer != this._leading_viewer) {
                    this._adjust_viewport(this._leading_viewer, viewer);
                }
            }

            this._leading_viewer = null;
        },

        _pre_check: function() {
            var self = this;
            if (this.viewers.length == 0) {
                console.warn("Openseadragonが初期化されていません");
            }
            else if (this.viewers.length == 1) { 
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_left,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'left'); 
                    }
                });
            
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_right,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'right'); 
                    }
                });
            }
            else if (this.viewers.length == 2) { 
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_left,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'left'); 
                    }
                });
            
                this.viewers[1].addTiledImage( {
                    tileSource: this._tile_source_right,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'right'); 
                    }
                });
            }
        },

        _on_added_tile_image: function(event, who) {
            if (who === 'left') {
                this.left_image = event.item;
                this.left_image_flag = true; 
                this._images_loaded(); 
            }
            else {
                this.right_image = event.item;
                this.right_image_flag = true;
                this._images_loaded();
            }

            if (this._both_loaded()) {
                this.emit('loaded');
            }
        },

        _images_loaded: function() {
            if(!this._both_loaded()){
                return;
            }
    
            this._left_rect.height = this.left_image.getContentSize().y;
            this._right_rect.height = this.right_image.getContentSize().y;

            if (this._containers.length == 1) {
                this._images_clip();
                this._init_clip(); 
            }
        },

        _both_loaded: function() {
            return this.left_image_flag && this.right_image_flag;
        },

        _images_clip: function() {
            //■tileSourceの左右が両方読み込み完了していない場合は処理しない
            if(!this._both_loaded()){
                //console.log("★imagesClip★読み込み未完了");
                return;
            }

            var rox = this.right_image.viewerElementToImageCoordinates( this.division_pt ).x;
            var lox = this.left_image.viewerElementToImageCoordinates( this.division_pt ).x;
            this._right_rect.x = rox ;
            this._right_rect.width = this.right_image.getContentSize().x - rox;
            this._left_rect.width = lox;  


            this.left_image.setClip( this._left_rect );
            this.right_image.setClip( this._right_rect );
        },

        _update_container_dimensions: function() {
            this.containerWidth = this.$container.outerWidth();
            this.containerOffset = this.$container.offset().left;
            this.minLeft = this.containerOffset + 10;
            this.maxLeft = this.containerOffset + this.containerWidth - this.dragWidth - 10;


            var offset = this.$handle.offset().left + this.dragWidth / 2;
            var event;


            event = new jQuery.Event("mousedown");
            event.pageX = offset;

            this.$handle.trigger( event ); 

            event = new jQuery.Event("mousemove");
            event.pageX = offset;


            this.$container.trigger( event );

            this.$handle.trigger("mouseup"); 
        },

        _mouse_down: function(e) {
            this._x_position = this.$handle.offset().left + this.dragWidth - e.pageX; 
            this._is_grabbing = true;

            e.preventDefault();
        },

        _mouse_move: function(e) {
            if (this._is_grabbing) {
                var leftValue = e.pageX + this._x_position - this.dragWidth; 
                leftValue = Math.max(leftValue, this.minLeft);
                leftValue = Math.min(leftValue, this.maxLeft);
    
                var widthPixel = (leftValue + this.dragWidth/2 - this.containerOffset);
                // var widthFraction = widthPixel/this.containerWidth;
                // var widthPercent = widthFraction*100+'%';
                
                // this.$handle.css('left', widthPercent);
     
                this._update_division_pt(widthPixel);
                this._images_clip();
            }
        },

        _mouse_up: function() {
            this._is_grabbing = false;
        },

        _init_clip: function() {  
            this.$handle = jQuery('.slider-handle');
            this.$container = this.$handle.parents('.slider-container'); 
            this.dragWidth = this.$handle.outerWidth(); 
            // this.containerWidth, containerOffset, minLeft, maxLeft;
            // var self = this;

            this._update_container_dimensions(); 

            jQuery(window).resize( this._update_container_dimensions.bind(this) );

            this._is_grabbing = false; 

            this.$handle.on("mousedown vmousedown", this._mouse_down.bind(this));
            this.$container.on("mousemove vmousemove", this._mouse_move.bind(this)); 
            this.$container.on("mouseup vmouseup", this._mouse_up.bind(this)); 
        },

        _update_division_pt: function(offset) {
            this.division_pt.x = offset;
        },

    };

    // イベントの機能を付与
    if (typeof(Emitter) !== 'undefined') {
        Emitter($.DualMap.prototype);
    }
})(ABDOMap);